import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import SvgTrue from "@/assets/icons/check.svg";
import SvgFalse from "@/assets/icons/close.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateIsMarked',
  props: {
    text: null,
    isMarked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    text: string,
    isMarked: boolean,
}



const getMarkingData = computed(() => {
    const trueData = { icon: SvgTrue, tooltipText: 'Маркируется', class: '--true' };
    const falseData = { icon: SvgFalse, tooltipText: 'Не маркируется', class: '--false' };
    return props.isMarked ? trueData : falseData;
});


return { __sfc: true,props, getMarkingData, BaseTooltip }
}

})